<template>
	<eg-modal :show="show" @close="$emit('close', false)">
		<p class="center" slot="header"><b>Documentos</b></p>
		<div slot="body">
			<div
				v-for="(document, index) in documents"
				:key="index"
				class="link"
			>
				<a :href="document.link" target="_blank">{{
					document.title
				}}</a>
				- {{ dateFilter(document.created_at) }}
			</div>
		</div>
	</eg-modal>
</template>

<script>
import {dateFilter} from '@/utils/filters';
export default {
    name: 'PublicDocuments',
    props: {
        documents: Array,
        show: Boolean,
    },
    methods: {
        dateFilter,
    },
};
</script>

<style></style>
